import Link from 'next/link';
import { usePathname } from 'next/navigation';

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: React.ReactNode;
}

const InnBLink = ({ href, children, ...rest }: Readonly<Props>) => {
  const pathname = usePathname();

  const isNewPath = (path: string) => {
    return path.includes('en-gb') || path.includes('de-de');
  };

  const isAnchor = () => {
    const pagePath = isNewPath(pathname ?? '');
    const linkPath = isNewPath(href ?? '');

    return pagePath !== linkPath;
  };

  if (isAnchor()) {
    return (
      <a data-type="anchor" {...rest} href={href ?? '/'}>
        {children}
      </a>
    );
  }

  return (
    <Link {...rest} href={href ?? '/'}>
      {children}
    </Link>
  );
};

export default InnBLink;
